/*
 * Copyright (c) 2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// This file is autogenerated by this script: packages/cp-shared-ui/scripts/populate-countries-cities-json.ts.
import { PhoneCodes } from '../../models/zones'
export const PHONE_CODES: PhoneCodes = {
  AF: { phoneCode: '93', name: 'Afghanistan' },
  AX: { phoneCode: '358', name: 'Aland Islands' },
  AL: { phoneCode: '355', name: 'Albania' },
  DZ: { phoneCode: '213', name: 'Algeria' },
  AS: { phoneCode: '1', name: 'American Samoa' },
  AD: { phoneCode: '376', name: 'Andorra' },
  AO: { phoneCode: '244', name: 'Angola' },
  AI: { phoneCode: '1', name: 'Anguilla' },
  AQ: { phoneCode: '672', name: 'Antarctica' },
  AG: { phoneCode: '1', name: 'Antigua and Barbuda' },
  AR: { phoneCode: '54', name: 'Argentina' },
  AM: { phoneCode: '374', name: 'Armenia' },
  AW: { phoneCode: '297', name: 'Aruba' },
  AU: { phoneCode: '61', name: 'Australia' },
  AT: { phoneCode: '43', name: 'Austria' },
  AZ: { phoneCode: '994', name: 'Azerbaijan' },
  BH: { phoneCode: '973', name: 'Bahrain' },
  BD: { phoneCode: '880', name: 'Bangladesh' },
  BB: { phoneCode: '1', name: 'Barbados' },
  BY: { phoneCode: '375', name: 'Belarus' },
  BE: { phoneCode: '32', name: 'Belgium' },
  BZ: { phoneCode: '501', name: 'Belize' },
  BJ: { phoneCode: '229', name: 'Benin' },
  BM: { phoneCode: '1', name: 'Bermuda' },
  BT: { phoneCode: '975', name: 'Bhutan' },
  BO: { phoneCode: '591', name: 'Bolivia' },
  BQ: { phoneCode: '599', name: 'Bonaire, Sint Eustatius and Saba' },
  BA: { phoneCode: '387', name: 'Bosnia and Herzegovina' },
  BW: { phoneCode: '267', name: 'Botswana' },
  BV: { phoneCode: '0055', name: 'Bouvet Island' },
  BR: { phoneCode: '55', name: 'Brazil' },
  IO: { phoneCode: '246', name: 'British Indian Ocean Territory' },
  BN: { phoneCode: '673', name: 'Brunei' },
  BG: { phoneCode: '359', name: 'Bulgaria' },
  BF: { phoneCode: '226', name: 'Burkina Faso' },
  BI: { phoneCode: '257', name: 'Burundi' },
  KH: { phoneCode: '855', name: 'Cambodia' },
  CM: { phoneCode: '237', name: 'Cameroon' },
  CA: { phoneCode: '1', name: 'Canada' },
  CV: { phoneCode: '238', name: 'Cape Verde' },
  KY: { phoneCode: '1', name: 'Cayman Islands' },
  CF: { phoneCode: '236', name: 'Central African Republic' },
  TD: { phoneCode: '235', name: 'Chad' },
  CL: { phoneCode: '56', name: 'Chile' },
  CN: { phoneCode: '86', name: 'China' },
  CX: { phoneCode: '61', name: 'Christmas Island' },
  CC: { phoneCode: '61', name: 'Cocos (Keeling) Islands' },
  CO: { phoneCode: '57', name: 'Colombia' },
  KM: { phoneCode: '269', name: 'Comoros' },
  CG: { phoneCode: '242', name: 'Congo' },
  CK: { phoneCode: '682', name: 'Cook Islands' },
  CR: { phoneCode: '506', name: 'Costa Rica' },
  HR: { phoneCode: '385', name: 'Croatia' },
  CU: { phoneCode: '53', name: 'Cuba' },
  CW: { phoneCode: '599', name: 'Curaçao' },
  CY: { phoneCode: '357', name: 'Cyprus' },
  CZ: { phoneCode: '420', name: 'Czech Republic' },
  CD: { phoneCode: '243', name: 'Democratic Republic of the Congo' },
  DK: { phoneCode: '45', name: 'Denmark' },
  DJ: { phoneCode: '253', name: 'Djibouti' },
  DM: { phoneCode: '1', name: 'Dominica' },
  DO: { phoneCode: '1', name: 'Dominican Republic' },
  EC: { phoneCode: '593', name: 'Ecuador' },
  EG: { phoneCode: '20', name: 'Egypt' },
  SV: { phoneCode: '503', name: 'El Salvador' },
  GQ: { phoneCode: '240', name: 'Equatorial Guinea' },
  ER: { phoneCode: '291', name: 'Eritrea' },
  EE: { phoneCode: '372', name: 'Estonia' },
  SZ: { phoneCode: '268', name: 'Eswatini' },
  ET: { phoneCode: '251', name: 'Ethiopia' },
  FK: { phoneCode: '500', name: 'Falkland Islands' },
  FO: { phoneCode: '298', name: 'Faroe Islands' },
  FJ: { phoneCode: '679', name: 'Fiji Islands' },
  FI: { phoneCode: '358', name: 'Finland' },
  FR: { phoneCode: '33', name: 'France' },
  GF: { phoneCode: '594', name: 'French Guiana' },
  PF: { phoneCode: '689', name: 'French Polynesia' },
  TF: { phoneCode: '262', name: 'French Southern Territories' },
  GA: { phoneCode: '241', name: 'Gabon' },
  GE: { phoneCode: '995', name: 'Georgia' },
  DE: { phoneCode: '49', name: 'Germany' },
  GH: { phoneCode: '233', name: 'Ghana' },
  GI: { phoneCode: '350', name: 'Gibraltar' },
  GR: { phoneCode: '30', name: 'Greece' },
  GL: { phoneCode: '299', name: 'Greenland' },
  GD: { phoneCode: '1', name: 'Grenada' },
  GP: { phoneCode: '590', name: 'Guadeloupe' },
  GU: { phoneCode: '1', name: 'Guam' },
  GT: { phoneCode: '502', name: 'Guatemala' },
  GG: { phoneCode: '44', name: 'Guernsey' },
  GN: { phoneCode: '224', name: 'Guinea' },
  GW: { phoneCode: '245', name: 'Guinea-Bissau' },
  GY: { phoneCode: '592', name: 'Guyana' },
  HT: { phoneCode: '509', name: 'Haiti' },
  HM: { phoneCode: '672', name: 'Heard Island and McDonald Islands' },
  HN: { phoneCode: '504', name: 'Honduras' },
  HK: { phoneCode: '852', name: 'Hong Kong S.A.R.' },
  HU: { phoneCode: '36', name: 'Hungary' },
  IS: { phoneCode: '354', name: 'Iceland' },
  IN: { phoneCode: '91', name: 'India' },
  ID: { phoneCode: '62', name: 'Indonesia' },
  IR: { phoneCode: '98', name: 'Iran' },
  IQ: { phoneCode: '964', name: 'Iraq' },
  IE: { phoneCode: '353', name: 'Ireland' },
  IL: { phoneCode: '972', name: 'Israel' },
  IT: { phoneCode: '39', name: 'Italy' },
  CI: { phoneCode: '225', name: 'Ivory Coast' },
  JM: { phoneCode: '1', name: 'Jamaica' },
  JP: { phoneCode: '81', name: 'Japan' },
  JE: { phoneCode: '44', name: 'Jersey' },
  JO: { phoneCode: '962', name: 'Jordan' },
  KZ: { phoneCode: '7', name: 'Kazakhstan' },
  KE: { phoneCode: '254', name: 'Kenya' },
  KI: { phoneCode: '686', name: 'Kiribati' },
  XK: { phoneCode: '383', name: 'Kosovo' },
  KW: { phoneCode: '965', name: 'Kuwait' },
  KG: { phoneCode: '996', name: 'Kyrgyzstan' },
  LA: { phoneCode: '856', name: 'Laos' },
  LV: { phoneCode: '371', name: 'Latvia' },
  LB: { phoneCode: '961', name: 'Lebanon' },
  LS: { phoneCode: '266', name: 'Lesotho' },
  LR: { phoneCode: '231', name: 'Liberia' },
  LY: { phoneCode: '218', name: 'Libya' },
  LI: { phoneCode: '423', name: 'Liechtenstein' },
  LT: { phoneCode: '370', name: 'Lithuania' },
  LU: { phoneCode: '352', name: 'Luxembourg' },
  MO: { phoneCode: '853', name: 'Macau S.A.R.' },
  MG: { phoneCode: '261', name: 'Madagascar' },
  MW: { phoneCode: '265', name: 'Malawi' },
  MY: { phoneCode: '60', name: 'Malaysia' },
  MV: { phoneCode: '960', name: 'Maldives' },
  ML: { phoneCode: '223', name: 'Mali' },
  MT: { phoneCode: '356', name: 'Malta' },
  IM: { phoneCode: '44', name: 'Man (Isle of)' },
  MH: { phoneCode: '692', name: 'Marshall Islands' },
  MQ: { phoneCode: '596', name: 'Martinique' },
  MR: { phoneCode: '222', name: 'Mauritania' },
  MU: { phoneCode: '230', name: 'Mauritius' },
  YT: { phoneCode: '262', name: 'Mayotte' },
  MX: { phoneCode: '52', name: 'Mexico' },
  FM: { phoneCode: '691', name: 'Micronesia' },
  MD: { phoneCode: '373', name: 'Moldova' },
  MC: { phoneCode: '377', name: 'Monaco' },
  MN: { phoneCode: '976', name: 'Mongolia' },
  ME: { phoneCode: '382', name: 'Montenegro' },
  MS: { phoneCode: '1', name: 'Montserrat' },
  MA: { phoneCode: '212', name: 'Morocco' },
  MZ: { phoneCode: '258', name: 'Mozambique' },
  MM: { phoneCode: '95', name: 'Myanmar' },
  NA: { phoneCode: '264', name: 'Namibia' },
  NR: { phoneCode: '674', name: 'Nauru' },
  NP: { phoneCode: '977', name: 'Nepal' },
  NL: { phoneCode: '31', name: 'Netherlands' },
  NC: { phoneCode: '687', name: 'New Caledonia' },
  NZ: { phoneCode: '64', name: 'New Zealand' },
  NI: { phoneCode: '505', name: 'Nicaragua' },
  NE: { phoneCode: '227', name: 'Niger' },
  NG: { phoneCode: '234', name: 'Nigeria' },
  NU: { phoneCode: '683', name: 'Niue' },
  NF: { phoneCode: '672', name: 'Norfolk Island' },
  KP: { phoneCode: '850', name: 'North Korea' },
  MK: { phoneCode: '389', name: 'North Macedonia' },
  MP: { phoneCode: '1', name: 'Northern Mariana Islands' },
  NO: { phoneCode: '47', name: 'Norway' },
  OM: { phoneCode: '968', name: 'Oman' },
  PK: { phoneCode: '92', name: 'Pakistan' },
  PW: { phoneCode: '680', name: 'Palau' },
  PS: { phoneCode: '970', name: 'Palestinian Territory Occupied' },
  PA: { phoneCode: '507', name: 'Panama' },
  PG: { phoneCode: '675', name: 'Papua New Guinea' },
  PY: { phoneCode: '595', name: 'Paraguay' },
  PE: { phoneCode: '51', name: 'Peru' },
  PH: { phoneCode: '63', name: 'Philippines' },
  PN: { phoneCode: '870', name: 'Pitcairn Island' },
  PL: { phoneCode: '48', name: 'Poland' },
  PT: { phoneCode: '351', name: 'Portugal' },
  PR: { phoneCode: '1', name: 'Puerto Rico' },
  QA: { phoneCode: '974', name: 'Qatar' },
  RE: { phoneCode: '262', name: 'Reunion' },
  RO: { phoneCode: '40', name: 'Romania' },
  RU: { phoneCode: '7', name: 'Russia' },
  RW: { phoneCode: '250', name: 'Rwanda' },
  SH: { phoneCode: '290', name: 'Saint Helena' },
  KN: { phoneCode: '1', name: 'Saint Kitts and Nevis' },
  LC: { phoneCode: '1', name: 'Saint Lucia' },
  PM: { phoneCode: '508', name: 'Saint Pierre and Miquelon' },
  VC: { phoneCode: '1', name: 'Saint Vincent and the Grenadines' },
  BL: { phoneCode: '590', name: 'Saint-Barthelemy' },
  MF: { phoneCode: '590', name: 'Saint-Martin (French part)' },
  WS: { phoneCode: '685', name: 'Samoa' },
  SM: { phoneCode: '378', name: 'San Marino' },
  ST: { phoneCode: '239', name: 'Sao Tome and Principe' },
  SA: { phoneCode: '966', name: 'Saudi Arabia' },
  SN: { phoneCode: '221', name: 'Senegal' },
  RS: { phoneCode: '381', name: 'Serbia' },
  SC: { phoneCode: '248', name: 'Seychelles' },
  SL: { phoneCode: '232', name: 'Sierra Leone' },
  SG: { phoneCode: '65', name: 'Singapore' },
  SX: { phoneCode: '1721', name: 'Sint Maarten (Dutch part)' },
  SK: { phoneCode: '421', name: 'Slovakia' },
  SI: { phoneCode: '386', name: 'Slovenia' },
  SB: { phoneCode: '677', name: 'Solomon Islands' },
  SO: { phoneCode: '252', name: 'Somalia' },
  ZA: { phoneCode: '27', name: 'South Africa' },
  GS: { phoneCode: '500', name: 'South Georgia' },
  KR: { phoneCode: '82', name: 'South Korea' },
  SS: { phoneCode: '211', name: 'South Sudan' },
  ES: { phoneCode: '34', name: 'Spain' },
  LK: { phoneCode: '94', name: 'Sri Lanka' },
  SD: { phoneCode: '249', name: 'Sudan' },
  SR: { phoneCode: '597', name: 'Suriname' },
  SJ: { phoneCode: '47', name: 'Svalbard and Jan Mayen Islands' },
  SE: { phoneCode: '46', name: 'Sweden' },
  CH: { phoneCode: '41', name: 'Switzerland' },
  SY: { phoneCode: '963', name: 'Syria' },
  TW: { phoneCode: '886', name: 'Taiwan' },
  TJ: { phoneCode: '992', name: 'Tajikistan' },
  TZ: { phoneCode: '255', name: 'Tanzania' },
  TH: { phoneCode: '66', name: 'Thailand' },
  BS: { phoneCode: '1', name: 'The Bahamas' },
  GM: { phoneCode: '220', name: 'The Gambia' },
  TL: { phoneCode: '670', name: 'Timor-Leste' },
  TG: { phoneCode: '228', name: 'Togo' },
  TK: { phoneCode: '690', name: 'Tokelau' },
  TO: { phoneCode: '676', name: 'Tonga' },
  TT: { phoneCode: '1', name: 'Trinidad and Tobago' },
  TN: { phoneCode: '216', name: 'Tunisia' },
  TR: { phoneCode: '90', name: 'Turkey' },
  TM: { phoneCode: '993', name: 'Turkmenistan' },
  TC: { phoneCode: '1', name: 'Turks and Caicos Islands' },
  TV: { phoneCode: '688', name: 'Tuvalu' },
  UG: { phoneCode: '256', name: 'Uganda' },
  UA: { phoneCode: '380', name: 'Ukraine' },
  AE: { phoneCode: '971', name: 'United Arab Emirates' },
  GB: { phoneCode: '44', name: 'United Kingdom' },
  US: { phoneCode: '1', name: 'United States' },
  UM: { phoneCode: '1', name: 'United States Minor Outlying Islands' },
  UY: { phoneCode: '598', name: 'Uruguay' },
  UZ: { phoneCode: '998', name: 'Uzbekistan' },
  VU: { phoneCode: '678', name: 'Vanuatu' },
  VA: { phoneCode: '379', name: 'Vatican City State (Holy See)' },
  VE: { phoneCode: '58', name: 'Venezuela' },
  VN: { phoneCode: '84', name: 'Vietnam' },
  VG: { phoneCode: '1', name: 'Virgin Islands (British)' },
  VI: { phoneCode: '1', name: 'Virgin Islands (US)' },
  WF: { phoneCode: '681', name: 'Wallis and Futuna Islands' },
  EH: { phoneCode: '212', name: 'Western Sahara' },
  YE: { phoneCode: '967', name: 'Yemen' },
  ZM: { phoneCode: '260', name: 'Zambia' },
  ZW: { phoneCode: '263', name: 'Zimbabwe' }
}
